export const stuffedPizza = [
	{
		id: 1,
		title: 'Cheese Deep Dish',
		price: '$ 16.99',
		description: 'Our signature Wisconsin mozarella cheese',
	},
	{
		id: 2,
		title: 'The Special',
		price: '$ 21.99',
		description: 'Sausage, mushroom, green peppers, onions',
	},
	{
		id: 3,
		title: 'Classic',
		price: '$ 21.99',
		description: 'Pepperoni, mushroom, green peppers, onions',
	},
	{
		id: 4,
		title: 'Meat and More Meat',
		price: '$ 26.99',
		description: 'Peperoni, salami, sausage & bacon',
	},
	{
		id: 5,
		title: 'Super Veggie',
		price: '$ 31.99',
		description:
			'Mushrrom, green peppers, onions, garlic, broccoli, black olives & spinach',
	},
];
export const thinCrust = [
	{
		id: 1,
		title: 'Cheese Thin Crust',
		price: '$ 15.99',
		description: 'Our signature Wisconsin mozarella cheese',
	},
	{
		id: 2,
		title: 'The Special',
		price: '$ 19.99',
		description: 'Sausage, mushroom, green peppers, onions',
	},
	{
		id: 3,
		title: 'Classic',
		price: '$ 19.99',
		description: 'Pepperoni, mushroom, green peppers, onions',
	},
	{
		id: 4,
		title: 'Meat and More Meat',
		price: '$ 23.99',
		description: 'Peperoni, salami, sausage & bacon',
	},
	{
		id: 5,
		title: 'Super Veggie',
		price: '$ 26.99',
		description:
			'Mushrrom, green peppers, onions, garlic, broccoli, black olives & spinach',
	},
];
export const extraThinCrust = [
	{
		id: 1,
		title: 'Cheese Extra Thin Crust',
		price: '$ 14.99',
		description: 'Our signature Wisconsin mozarella cheese',
	},
	{
		id: 2,
		title: 'The Special',
		price: '$ 18.99',
		description: 'Sausage, mushroom, green peppers, onions',
	},
	{
		id: 3,
		title: 'Classic',
		price: '$ 18.99',
		description: 'Pepperoni, mushroom, green peppers, onions',
	},
	{
		id: 4,
		title: 'Meat and More Meat',
		price: '$ 22.99',
		description: 'Peperoni, salami, sausage & bacon',
	},
	{
		id: 5,
		title: 'Super Veggie',
		price: '$ 25.99',
		description:
			'Mushrrom, green peppers, onions, garlic, broccoli, black olives & spinach',
	},
];
export const starters = [
	{
		id: 1,
		title: 'Boneless Chicken Nuggets',
		price: '$ 13.49',
		description:
			'All white meat tender chicken bites served with our signature ranch dipping sauce.',
	},
	{
		id: 2,
		title: 'Cheesy Garlic Bread',
		price: '$ 9.99',
		description:
			'All white meat tender chicken bites served with our signature ranch dipping sauce.',
	},
	{
		id: 3,
		title: 'Calamari and more',
		price: '$ 13.49',
		description: 'Tender Calamari mixed with lemon rings, and banana peppers',
	},
	{
		id: 3,
		title: 'French Fries',
		price: '$ 5.99',
		description: 'Served with our signature dipping sauce',
	},
	{
		id: 4,
		title: 'Soup of the Day',
		price: '$ 4.99',
		description: 'Served with our signature dipping sauce',
	},
];
export const salads = [
	{
		id: 1,
		title: 'Chopped Salad',
		price: '$ 11.99',
		description:
			'Chicken breast, iceberg, diced tomatoes, bacon, red onion, red cabbage, pasta and bleu cheese crumbles',
	},
	{
		id: 2,
		title: 'Caesar Salad',
		price: '$ 12.99',
		description:
			'Lettuce and creamy Caesar dressing tossed with parmesan, romano and shaved asiago cheeses',
	},
	{
		id: 3,
		title: 'Greek Salad',
		price: '$ 12.99',
		description:
			'Greek feta cheese, cucumbers, baby tomatoes, bell peppers, Kalamata olives, red onion and banana peppers with iceberg lettuce ',
	},
	{
		id: 4,
		title: "Giordano's House Salad",
		price: '$ 9.99',
		description:
			'Chicken breast, iceberg, diced tomatoes, bacon, red onion, red cabbage, pasta and bleu cheese crumbles',
	},
];
export const sandwiches = [
	{
		id: 1,
		title: 'Chicken Parm',
		price: '$ 12.99',
		description:
			'Breaded chicken breast with our house-made marinara sauce and melted mozzarella on toasted garlic ciabatta bread',
	},
	{
		id: 2,
		title: 'Italian Beef',
		price: '$ 12.99',
		description:
			'Tender Italian-style beef on a toasted garlic Italian roll with sweet peppers, spicy giardiniera and a cup of beef jus',
	},
	{
		id: 3,
		title: "Mama's Meatball Sub",
		price: '$ 12.99',
		description:
			'All-beef meatballs with our house-made marinara sauce and melted provolone on a toasted garlic Italian roll',
	},
];
export const pastas = [
	{
		id: 1,
		title: 'Chicken Parmesan',
		price: '$ 16.99',
		description:
			'Breaded chicken breast with our house-made marinara sauce and melted mozzarella on toasted garlic ciabatta bread',
	},
	{
		id: 2,
		title: 'Fettuccine Alfredo',
		price: '$ 12.99',
		description:
			'Fettuccine noodles tossed in a creamy blend of parmesan and romano cheese.',
	},
	{
		id: 3,
		title: 'Spaghetti',
		price: '$ 12.99',
		description: 'Barilla® spaghetti tossed in our House-made marinara sauce',
	},
	{
		id: 4,
		title: 'Spaghetti with meat sauce',
		price: '$ 12.99',
		description: 'Barilla® spaghetti tossed in our House-made bolognese sauce',
	},
];
export const desserts = [
	{
		id: 1,
		title: 'Oversized Skillet Cookie',
		price: '$ 5.79',
		description:
			'Chocolate Chip Cookie freshly baked in our pizza oven and topped with a scoop of vanilla ice cream and chocolate sauce',
	},
];
